<template>
  <div id="app"><div id="GenomesPie" class="GenomesPie"></div></div>
</template>
      
      <script>
import * as echarts from "echarts";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GenomesPie",
  data() {
    return {
      pie: [],
      data: [],
      styles: [
        { color: "rgb(23, 69, 143)" },
        { color: "rgb(42, 163, 127)" },
        { color: "rgb(181, 181, 47)" },
        { color: "rgb(193, 88, 65)" },
        { color: "rgb(85, 172, 199)" },
      ],
    };
  },
  methods: {
    async initChart() {
      this.pie = [];
      this.data = [];
      this.char = echarts.init(document.getElementById("GenomesPie"));
      this.char.setOption({
        title: {
          text: "Genome statistics",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        // legend: {
        //   orient: "vertical",
        //   left: "left",
        // },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      });
      await this.$axios.get("/api/api.echarts/pieChart/genomes").then((res) => {
        this.pie = res.data.data;
        this.pie.forEach((element) => {
// 将group 为Phycophyta 的数据替换为Algae，学名修改
          if (element.name != null) {
            if (element.name == "Phycophyta") {
              element.name = "Algae";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Angiosperm") {
              element.name = "Angiosperms";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Gymnosperm") {
              element.name = "Gymnosperms";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Bryophyte") {
              element.name = "Bryophytes";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Pteridophyte") {
              element.name = "Pteridophytes";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            this.data.push(element);
          }
        });
        this.char.setOption({
          series: [
            {
              type: "pie",
              radius: ['40%', '70%'],
              center: ["50%", "50%"],
              selectedMode: "single",
              name: "genome",
              data: this.pie,
              label: {
                position: "outer",
                alignTo: "edge",
                margin: 0,
              },
            },
          ],
        });
      });
      console.log(this.data);
    },
  },

  async mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
};
</script>
      <style>
.GenomesPie {
  width: 300px;
  height: 250px;
  margin: auto;
  background-color: white;
  border-radius: 10px;
}
</style>